module.exports = __webpack_public_path__ + "img/down.cad61cf6.svg";